<template>
  <DialogTemplate :is-open="isOpen" class="DialogTemplateArea" @click-mask="onClickMask">
    <div class="errorContent" :class="{ isPc: !isSp }">
      <div class="title" :class="{ isPc: !isSp }" v-text="title" />
      <div
        v-for="message in detailErrorList"
        :key="message"
        class="detailError"
        :class="{ isPc: !isSp }"
        v-text="message"
      />
      <ButtonTypeCustom
        class="button"
        :class="{ isPc: !isSp }"
        button-type="button"
        :button-text="buttonCustomText"
        button-color="colorPrimary"
        button-size="sizeLarge"
        @button-clicked="onClickButton"
      />
    </div>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from './DialogTemplate.vue';
import ButtonTypeCustom from '../Button/ButtonTypeCustom.vue';

export default {
  name: 'Error',
  components: {
    DialogTemplate,
    ButtonTypeCustom,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    /**
     * テキスト。
     * 改行文字改行しますが、『title="sample"』形式だと改行文字効かないので、『:title="'sample'"』で送ってください
     */
    title: {
      type: String,
      required: true,
    },
    detailErrorList: {
      type: Array,
      required: false,
      default: () => [],
    },
    /**
     * ボタンカスタムテキスト
     * 入力なければ「閉じる」のまま
     */
    buttonCustomText: {
      type: String,
      required: false,
      default: '閉じる',
    },
    /**
     * 永続オプション
     * trueの場合はMaskクリックで消えない
     * falseの場合はMaskクリックで消える、返却はfalse
     * マスクを誤タップして消えるのを防ぐため、デフォルトtrue
     */
    persistent: {
      type: Boolean,
      required: false,
      default: true,
    },
    isSpFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  computed: {
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
  },
  methods: {
    onClickMask() {
      if (!this.persistent) {
        this.$emit('click-dialog-mask');
      }
    },
    onClickButton() {
      this.$emit('click-dialog-button');
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

@mixin text() {
  white-space: pre-wrap;
  text-align: center;
  line-height: $text-line-height-default;
}

.errorContent {
  max-width: 440px;

  &.isPc {
    max-width: none;
    width: 336px;
  }

  .title {
    @include text;

    margin-top: 12px;
    font-size: $text-size-paragraph1;
    font-weight: $text-weight-bold;
  }

  .detailError {
    @include text;

    white-space: pre-wrap;
    font-size: $text-size-paragraph2;
    margin-top: 16px;

    &.isPc {
      margin-top: 24px;
    }
  }

  .button {
    margin-top: 32px;

    &.isPc {
      margin-bottom: 12px;
    }
  }
}
</style>
